class Validator {

  static required(value) {
    if(value.length === 0) {
      return false
    }
    return true
  }

  static validateProduct(product) {
    const errors = [];
    if(product.name.length === 0) {
      errors.push({
        field: 'name',
        msg: 'Name is required field'
      });
    }
    if(product.barcode.length === 0) {
      errors.push({
        field: 'barcode',
        msg: 'Barcode is required field'
      });
    }
    if(product.hsn.length === 0) {
      errors.push({
        field: 'hsn',
        msg: 'HSN is required field'
      });
    }
    if(product.taxId.length === 0) {
      errors.push({
        field:'taxId',
        msg: 'Tax is required field'
      });
    }
    if(product.unitId.length === 0) {
      errors.push({
        field: 'unitId',
        msg: 'Unit is required field'
      });
    }
    return errors;
  }

  static validateVendor(vendor) {
    const errors = [];
    if(vendor.phone.length === 0) {
      errors.push({
        field: 'phone',
        msg: 'Phone is required field'
      });
    }
    return errors;

  }

  static validateChangePassword(data) {
    const errors = [];
    if (data.password.length === 0) {
      errors.push({
        field: 'password',
        msg: 'Password is required field'
      });
    }
    if (data.confirmPassword.length === 0) {
      errors.push({
        field: 'confirmPassword',
        msg: 'Confirm Password is required field'
      });
    }
    if (data.password && data.confirmPassword) {
      if (data.password != data.confirmPassword) {
        errors.push({
          field: 'confirmPassword',
          msg: 'Confirm Password does not match with password'
        });
      }
    }
    return errors;
  }

  static validateServiceRequest(serviceRequest) {
    const errors = [];
    if (serviceRequest.userId === null) {
      errors.push({
        field : 'customer-name',
        msg : 'Customer Name Required!'
      });
    }
    if(serviceRequest.serviceJobsMeta.length === 0) {
      errors.push({
        field : 'service',
        msg : 'No Service Selected!'
      });
    }
    if(serviceRequest.customerAddressId === null) {
      errors.push({
        field: 'address',
        msg: 'Select Atleast One Address!'
      })
    }
  return errors
  }

  static validateUser(user) {
    const errors = [];
    if(user.firstName === "" || user.firstName === null) {
      errors.push({
        field : 'firstName',
        msg : 'First Name Required!'
      })
    }
    if(user.locality === "" || user.locality === null) {
      errors.push({
        field : 'locality',
        msg : 'Locality Required!'
      })
    }
    if(user.phone === "" || user.phone === null) {
      errors.push({
        field : 'phone',
        msg : 'Phone Required!'
      })
    }
    if(user.pinCode === "" || user.pinCode === null) {
      errors.push({
        field : 'pincode',
        msg : 'Pincode Required!'
      })
    }
    if (user.addresses.length && (user.addresses[0].address === '' || user.addresses[0].marathiAddress === '')) {
      errors.push({
        field: 'address',
        msg: 'Address Require'
      })
    }
  return errors

  }
}

export default Validator;
